import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { HelpCircle } from "lucide-react";

export default function FaqSection({ limit }) {
  const items = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section className="bg-white py-24 md:py-32" data-testid="faq">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="text-center mb-12">
            <span className="text-royal text-xs font-semibold tracking-[0.3em] uppercase">FAQ</span>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold text-navy-deep mt-3">Questions, Answered</h2>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border border-slate-200 rounded-lg px-5 data-[state=open]:border-royal/40 data-[state=open]:bg-soft-grey/60" data-testid={`faq-${i}`}>
                <AccordionTrigger className="text-left font-display font-semibold text-navy-deep hover:no-underline py-5">
                  <span className="flex items-center gap-3"><HelpCircle className="h-5 w-5 text-royal shrink-0" />{f.q}</span>
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5 pl-8">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
